module.exports = __webpack_public_path__ + "static/media/circle.0799ebb9.png";